import { useQuery } from "@tanstack/react-query";

import { api } from "utils/axios";
import useUrlParams from "utils/urlParms";

const GET_ANNOUNCEMENTS_QUERY = "get-announcements";

const getAnnouncements = async (params) => {
  try {
    const response = await api.get(`/announcement`, { params });
    return response.data;
  } catch (e) {
    console.error(e, "Error fetching announcements");
  }
};

const useGetAnnouncements = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_ANNOUNCEMENTS_QUERY, params],

    queryFn: () => getAnnouncements(params),
  });
};

export { useGetAnnouncements, GET_ANNOUNCEMENTS_QUERY };
